import React, { useState, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import { addliveOneSecKeyarData } from "../../../redux/features/central_monitor/liveOneSecKeyarData";
import Cookie from "js-cookie";
import axios from "axios";
import urls from "../../../utils/url";
import "./GraphCard.scss";
import ChartLayout2 from "./chartLayout2";
import { deleteFromIndexedDB, deleteFetalMarkers } from "../../../utils/IndexedDB";
import { useNavigate } from "react-router-dom";
import { isRealPatientId, getAgeDisplay } from "../../../utils/converter";

const GraphCard = ({
  patientID,
  isBeingCleaned,
  patientName,
  keyarData,
  session_time,
  session_uuid,
  assignedPatientId,
  liveBasicDetail,
  addliveOneSecKeyarData,
  index,
  count,
  onPatientCleanup,
  onAlertChange,
  onOpenSingleCard,
  isSingleView = false,
   hospitalName,
  hospitalLogo,
}) => {
  const cookie = Cookie.get("access_token");
  const cookieData = Cookie.get("data");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [patientBasicDetail, setPatientBasicDetail] = useState();
  const [interpretationsDisable, setInterpretationsDisable] = useState("");
  const [accountType, setAccountType] = useState("");
  const basicDetailFetchedRef = useRef(false);
  const navigate = useNavigate();
  const [isCritical, setIsCritical] = useState(false);

  const handleCardClick = () => {
    if (isSingleView) return;
    onOpenSingleCard?.(patientID);
  };

  useEffect(() => {
    if (cookieData) {
      const parsedData = JSON.parse(cookieData);
      const algorithm = parsedData.fetal_distress_algorithm;
      const account_type = parsedData.account_type;
      setAccountType(account_type);
      setInterpretationsDisable(algorithm);
    }
  }, [cookieData]);

  // delete data from indexdb on unmount of card
  // useEffect(() => {
  //   const currentPatientID = patientID;
  //   return () => {
  //     console.log(`[${currentPatientID}] 🗑️ Card removed - cleaning IndexedDB`);
  //     deleteFromIndexedDB(currentPatientID);
  //   };
  // }, []);

  useEffect(() => {
    if (isBeingCleaned) {
      console.log(`[${patientID}] 🧹 Clearing GraphCard state`);
      setPatientBasicDetail(null);
      basicDetailFetchedRef.current = false;
    }
  }, [isBeingCleaned, patientID]);

  // useEffect(() => {
  //   basicDetailFetchedRef.current = false;
  //   console.log(`[${patientID}] Resetting basic detail fetch flag`);
  // }, [patientID]);

  // The card keeps one identity (patientID) for the whole session; the real
  // patient ID, once a patient is assigned mid-session, arrives separately as
  // assignedPatientId. Fall back to patientID for REST-sourced cards.
  const detailPatientId = assignedPatientId ?? patientID;

  useEffect(() => {
    if (basicDetailFetchedRef.current) {
      console.log(`[${patientID}] Basic details already fetched, skipping`);
      return;
    }

    if (!isRealPatientId(detailPatientId)) {
      // Unassigned/emergency session — no patient yet (the ID is a
      // session_uuid or 0), this endpoint expects a real numeric patient ID
      // and will 400/404. Re-runs when assignedPatientId becomes real.
      setLoading(false);
      return;
    }

    setLoading(true);
    basicDetailFetchedRef.current = true;

    axios
      .get(
        `${urls.DEV_URL}v1/nurse/patients/?patient_ids=${detailPatientId}&forms=basic_detail,pa_pv_examination`,
        {
          headers: {
            "Request-ID": "allow|me",
            "Content-Type": "application/json",
            Authorization: `Bearer ${cookie}`,
          },
        },
      )
      .then((res) => {
        if (res.data) {
          const json_data = res.data;
          const basic = json_data.response[0].basic_detail;
          const pv = json_data.response[0].pa_pv_examination || {};

          setPatientBasicDetail({
            name: basic.name || "-",
            age: getAgeDisplay(basic.dob, basic.age),
            id: basic.id || "-",
            mrn: basic.mrn || "-",
            dob: basic.dob || "-",
            ges_period: pv.gestation_period || "-",
            monitoring_start_time: pv.monitoring_start_time || "-",
          });

          setLoading(false);
        }
      })
      .catch((err) => {
        console.log("Error in Fetching Data", err);
        setError(true);
        setLoading(false);
        basicDetailFetchedRef.current = false; // Allow retry on error
      });
  }, [patientID, detailPatientId, cookie]);

  return (
    <>
      {keyarData && keyarData.length > 0 ? (
        <div
          className={`graph-card-container 
             ${isCritical ? "is-critical" : ""}
    ${!isSingleView && isCritical ? "critical-card" : ""}
          `}
          role="button"
          tabIndex={0}
          onClick={handleCardClick}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleCardClick();
          }}
          style={{
            
            display: "flex",
            flexDirection: "column",
            boxSizing: "border-box",
            cursor: isSingleView ? "default" : "pointer",
          }}
        >
            {/* <div className="card-bg-layer" > */}
          {!isSingleView && isCritical && <div className="critical-overlay" />}

          <div className="graph-scaled">
            <ChartLayout2
              patientID={patientID}
              keyar_data={keyarData}
              session_time={session_time}
              session_uuid={session_uuid}
              patientBasicDetail={patientBasicDetail}
              monitoring_start_time={patientBasicDetail?.monitoring_start_time}
              viewMode={isSingleView ? "single" : "grid"}
              isBeingCleaned={isBeingCleaned}
              isCritical={isCritical}
              isSingleView={isSingleView}
              hospitalName={hospitalName}
  hospitalLogo={hospitalLogo}
              onCriticalChange={(critical, alerts) => {
                setIsCritical(critical);
                onAlertChange?.(patientID, critical, {
                  name: patientBasicDetail?.name,
                  age: patientBasicDetail?.age,
                  mrn: patientBasicDetail?.mrn,
                  alerts,
                });
              }}
            />
          </div>
          {/* </div> */}
        </div>
      ) : null}
    </>
  );
};

const mapStateToProps = (state) => ({
  liveBasicDetail: state.liveBasicDetail.liveBasicDetail,
});

const mapDispatchToProps = {
  addliveOneSecKeyarData,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(React.memo(GraphCard));
